var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWIllness4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0 0 77 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 55,
    rx: 27.5,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9242_6803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0856 22.2646C38.0494 23.0098 36.268 23.7401 33.4553 23.3207C33.9339 24.5494 32.4141 25.9163 32.4141 25.9163C32.4141 25.9163 33.0309 30.2834 36.421 32.504C37.5855 33.2688 39.0906 33.2491 40.2453 32.4694C41.2667 31.7786 42.456 30.5844 43.1912 28.5563C44.0943 26.2271 43.9068 25.0132 43.9068 25.0132C43.9068 25.0132 41.7898 24.801 41.094 23.9473",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1699 17.9766C43.9513 18.6033 45.9054 20.8288 45.9054 26.1828V33.0419",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6035 33.0419V23.2319C30.6035 20.6017 32.0592 18.2973 34.1564 17.0981",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2528 13.5059C34.9318 13.5059 33.7031 14.9961 33.7031 14.9961L34.8529 20.3502H41.6577L42.8075 14.9961C42.8075 14.9961 41.5788 13.5059 38.2578 13.5059H38.2479H38.2528Z",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.252 15.7212V18.4747",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6294 17.0981H36.8809",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2148 20.3447H42.199",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6701 41.4949C26.6701 41.4949 26.3445 38.0604 28.8463 36.5751C30.9929 35.4401 35.1971 33.3774 35.1971 33.3774L38.5132 41.4949",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3282 41.4652C50.3282 41.4652 50.6638 38.0653 48.1669 36.5799C46.0203 35.445 41.8161 33.3823 41.8161 33.3823L38.5 41.4997",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8809 36.999H40.0143",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.541,
    cy: 26.0542,
    r: 0.740191,
    fill: "#0D4248"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3144,
    cy: 26.0542,
    r: 0.740191,
    fill: "#0D4248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5684 29.0151C37.8514 30.007 39.0258 30.007 40.0769 29.0151",
    stroke: "#0D4248",
    strokeWidth: 0.986921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9242_6803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.673,
    height: 28.976,
    fill: "white",
    transform: "translate(26.1621 13.0122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWIllness4);
export default __webpack_public_path__ + "static/media/w-illness4.c43f26011c0c4cdc015e72c03d404e7f.svg";
export { ForwardRef as ReactComponent };